import '.c2{flex-shrink:0;}.ssr-plugin'
import '.c3{padding:1rem;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ba{background-color:transparent;}.ssr-plugin'
import '.ep{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.db{position:sticky;}.ssr-plugin'
import '.eq{top:4rem;}.ssr-plugin'
import '.er{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.es{padding-bottom:1rem;}.ssr-plugin'
import '.p{margin-bottom:1rem;}.ssr-plugin'
import '.et{border-bottom:var(--blue-border);}.ssr-plugin'
import '.w{position:fixed;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.eu{bottom:0px;}.ssr-plugin'
import '.ec{z-index:9999;}.ssr-plugin'
import '.ev{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.c4{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c2 c3 z bk b9 ba ep"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d k ab"
    >
      <div className="db eq er ae es p et d"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="w cg bi bj eu ec ae ev d k"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c3 d cv et"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c4 at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
